import { Button } from '../button/Button';
import { withPersonalizedButtonStyle } from '../button/withPersonalizedButtonStyle';
import { styles } from './GhostButton.styles';

export const GhostButton = withPersonalizedButtonStyle(Button, styles);
